import {cssTheme} from '@yandex-delivery/blocks';
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const listClasses = {
  root: css`
    display: flex;
    flex-direction: column;
    inline-size: 100%;
    list-style-type: none;
  `,
  listItem: css`
    padding-block: ${spacing(2.25)};
  `,
  separator: css`
    inline-size: 100%;
    opacity: 0.1;
    block-size: ${spacing(0.25)};
    background: ${cssTheme.default.day.everWhite};
  `,
}
